import { Directive, inject, output } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

import { Languages, TranslationService } from "src/app/core";

@Directive({
  selector: "[isEnglish]",
  standalone: true,
})
export class IsEnglishDirective {
  private translation = inject(TranslationService);

  readonly isEnglish = output<boolean>();

  constructor() {
    this.getCurrentLanguage();
  }

  private getCurrentLanguage() {
    this.translation.currentLanguage$.pipe(takeUntilDestroyed()).subscribe((land) => this.isEnglish.emit(land === Languages.EN));
    setTimeout(() => this.isEnglish.emit(this.translation.isEnglish));
  }
}
